const paddedAmount = (amount) => {
  const pad = "000";
  return (
    pad.substring(0, pad.length - amount.toString().length) + amount.toString()
  );
};
const padAmountEnd = (amount) => {
  const pad = "000";
  return (
    pad.substring(0, amount.toString().length - pad.length) + amount.toString()
  );
};

const decimal = (amount) => {
  return paddedAmount(amount).slice(-2);
};

const whole = (amount) => {
  return paddedAmount(amount).slice(0, -2);
};

const limitDecimals = (value, decimals = 2) => {
  const regex = new RegExp(`^\\d+\\.?\\d{0,${decimals}}`);
  return value.match(regex);
};

const amountWithSeparator = (amount, separator = ",") => {
  let stringAmount = amount.toFixed(2).toString();
  return stringAmount.replace(".", separator);
};

export {
  decimal,
  whole,
  paddedAmount,
  padAmountEnd,
  limitDecimals,
  amountWithSeparator,
};
